import { default as WebModal } from 'modal-react-native-web'
import { useEffect, useState } from 'react'
import { Animated, Dimensions, Easing, Modal as RNModal, Platform, ViewProps } from 'react-native'
import { Box } from '../BoxNew'
import { Icon } from '../IconNew'
import { ModBox } from '../ModifiedBox'
import { Text } from '../TextNew'
import { modalHeaderType, modalTypes } from './ModalTypes'
import { ModalDialogHeaderProps, ModalDialogProps } from './types'

const height = Dimensions.get('screen').height

const AnimateComponent = ({ title, animate, toggleSlide, dismiss, type, children }) => {
  if (animate) {
    return (
      <Animated.View style={{ transform: [{ translateY: toggleSlide }] }}>
        <>
          {!!title && <ModalHeader title={title} onDismiss={dismiss} center={type === 'centered'} />}
          {children}
        </>
      </Animated.View>
    )
  } else {
    return (
      <>
        {!!title && <ModalHeader title={title} onDismiss={dismiss} center={type === 'centered'} />}
        {children}
      </>
    )
  }
}

const AnimateOverlayComponent = ({ animate, type, opacity }: any) => {
  if (animate) {
    return (
      <Animated.View
        style={{ ...(modalTypes[type as keyof typeof modalTypes].background as ViewProps), opacity: opacity }}>
        <Box />
      </Animated.View>
    )
  } else {
    return (
      <ModBox {...modalTypes[type as keyof typeof modalTypes].background}>
        <Box />
      </ModBox>
    )
  }
}

const ModalDialog = ({
  type = 'centered',
  show = false,
  children,
  onDismiss,
  title,
  backgroundColor,
  borderRadius,
  onBackPress,
  animate = false,
}: ModalDialogProps) => {
  const Modal = Platform.OS === 'web' ? WebModal : RNModal
  const [openSlide] = useState<any>(new Animated.Value(0))
  const [openModal, setModal] = useState(false)

  const dismiss = () => {
    Animated.timing(openSlide, {
      toValue: 0,
      easing: Easing.inOut(Easing.ease),
      useNativeDriver: true,
      duration: 300,
    }).start(() => {
      setModal(false)
      onDismiss?.()
    })
  }

  useEffect(() => {
    if (show) {
      setModal(true)
      Animated.timing(openSlide, {
        toValue: 1,
        easing: Easing.inOut(Easing.ease),
        useNativeDriver: true,
        duration: 300,
      }).start()
    } else if (!show) {
      Animated.timing(openSlide, {
        toValue: 0,
        easing: Easing.inOut(Easing.ease),
        useNativeDriver: true,
        duration: 300,
      }).start(() => {
        //onDismiss?.()
        setModal(false)
      })
    }
  }, [openSlide, show])

  const toggleSlide = openSlide.interpolate({
    inputRange: [0, 1],
    outputRange: [height / 1.1, 0],
  })
  const opacity = openSlide.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  })

  const childComp = (
    <>
      <Box {...modalTypes[type as keyof typeof modalTypes].contentContainer} pointerEvents={'box-none'}>
        <Box
          {...modalTypes[type as keyof typeof modalTypes].innerContainer}
          safeArea
          {...(borderRadius && { borderTopLeftRadius: borderRadius, borderTopRightRadius: borderRadius })}
          {...(backgroundColor && { backgroundColor })}>
          <AnimateComponent
            title={title}
            animate={animate}
            toggleSlide={toggleSlide}
            dismiss={dismiss}
            type={type}
            children={children}
          />
        </Box>
      </Box>
      <AnimateOverlayComponent type={type} animate={animate} opacity={opacity} />
    </>
  )

  return (
    <Modal
      animationType={animate ? 'none' : 'fade'}
      transparent
      visible={openModal}
      ariaHideApp={false}
      onDismiss={onDismiss}
      onRequestClose={onBackPress}>
      {childComp}
    </Modal>
  )
}

const ModalHeader = ({
  title = '',
  onDismiss = () => { },
  center = false,
  type = 'default',
}: ModalDialogHeaderProps) => {
  return (
    <Box {...modalHeaderType[type as keyof typeof modalHeaderType].containerHeader(center)}>
      <Text {...modalHeaderType[type as keyof typeof modalHeaderType].headerTitle}>{title}</Text>
      {!center && (
        <Box
          onPress={onDismiss}
          underlayColor={'GREY_1_SEPARATOR'}
          {...modalHeaderType[type as keyof typeof modalHeaderType].containerButton}>
          <Icon id={'CLOSE'} size={16} />
        </Box>
      )}
    </Box>
  )
}

export { modalTypes, modalHeaderType }
export { ModalDialog }

